import Grid from '@mui/material/GridLegacy'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import Image from 'next/image'
import Link from 'next/link'
import React, { Fragment } from 'react'
import P from '@components/Components/Reusables/Typography/P'

import styles from './polishedCard.module.css';
import { s3Url } from '@components/config/helpers'

export default function PolishedCard({
    image,
    imageKey = 'image_id',
    imageSrc = 'image',
    imageTitle = 'title',
    imageAlt = 'alt',
    showTitle = true,
    imageProps = {},
    divStyles = {},
    ...rest
}) {

    const imageData = {
        imageKey: image[imageKey],
        image: image[imageSrc],
        title: image[imageTitle],
        alt: image[imageAlt]
    }

    return (
        <div className={`${styles.polished_card}`}>
            <Card
                sx={{
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',

                }}
                className="position-relative"
                {...rest}
            >
                <Image
                    src={s3Url(imageData.image)}
                    alt={imageData.alt}
                    {...imageProps}

                />
                {showTitle && (
                    <CardActions sx={{ p: 0 }} style={{ bottom: 0 }} className="position-absolute mt-2 p-1 align-content-center text-center w-available bg-primary background-grey">
                        <P className="w-100 vertical-auto text-center" color="secondary" sx={{ fontSize: 16, fontWeight: '500' }}>
                            {imageData.title}
                        </P>
                    </CardActions>
                )}
            </Card>
        </div>
    )
}
